/* ========================================
   Vitamira - Shopify theme script
   Ported from the prototype (script.js, home.js, product.js)
   with the fake cart replaced by Shopify's AJAX Cart API.
   ======================================== */
(function () {
  if (window.__vitamiraInit) return;
  window.__vitamiraInit = true;

  var CFG = window.VITAMIRA_CONFIG || {};
  var THRESHOLD = typeof CFG.freeShippingThreshold === 'number' ? CFG.freeShippingThreshold : 4000; /* cents */
  var SHOP_URL = CFG.shopUrl || '/collections/all';
  var SUGGESTIONS = window.VITAMIRA_PRODUCTS || [];
  var cartState = null;

  function money(cents) { return '$' + (cents / 100).toFixed(2); }
  function qs(id) { return document.getElementById(id); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* --- Toast --- */
  window.showToast = function (message) {
    var toast = qs('toast');
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('visible');
    clearTimeout(toast.__t);
    toast.__t = setTimeout(function () { toast.classList.remove('visible'); }, 2500);
  };

  /* --- Cart (Shopify AJAX API) --- */
  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { cartState = c; renderCart(); return c; });
  }

  window.vitamiraAddToCart = function (variantId, qty, name) {
    qty = qty || 1;
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add-failed');
      return fetchCart();
    }).then(function () {
      showToast((name || 'Product') + ' added to cart');
      openCartDrawer();
    }).catch(function () {
      showToast('Sorry, that could not be added to your cart.');
    });
  };

  /* Buy now: cart permalink goes straight to checkout */
  window.vitamiraBuyNow = function (variantId, qty) {
    window.location.href = '/cart/' + variantId + ':' + (qty || 1);
  };

  window.changeCartLine = function (lineKey, newQty) {
    fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: newQty })
    }).then(function (r) { return r.json(); })
      .then(function (c) { cartState = c; renderCart(); })
      .catch(function () { showToast('Could not update the cart.'); });
  };

  window.checkout = function () { window.location.href = '/checkout'; };

  function renderCart() {
    if (!cartState) return;
    var countEl = qs('cartCount');
    if (countEl) {
      countEl.textContent = cartState.item_count;
      countEl.classList.toggle('visible', cartState.item_count > 0);
    }
    var itemsEl = qs('cartItems');
    var emptyEl = qs('cartEmpty');
    var footerEl = qs('cartFooter');
    if (!itemsEl || !emptyEl || !footerEl) return;

    if (cartState.items.length === 0) {
      itemsEl.innerHTML = '';
      emptyEl.style.display = 'flex';
      footerEl.style.display = 'none';
      var box0 = qs('cartSuggestions');
      if (box0) box0.remove();
      return;
    }
    emptyEl.style.display = 'none';
    footerEl.style.display = 'block';

    itemsEl.innerHTML = cartState.items.map(function (item) {
      var img = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/, '_96x$1$2') : '';
      var variantLine = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';
      return '' +
        '<div class="cart-item">' +
          '<div class="cart-item-image">' +
            (img ? '<img src="' + esc(img) + '" alt="' + esc(item.product_title) + '" width="48" height="48" loading="lazy">' : '') +
          '</div>' +
          '<div class="cart-item-info">' +
            '<div class="cart-item-name">' + esc(item.product_title) + '</div>' +
            (variantLine ? '<div class="cart-item-variant">' + esc(variantLine) + '</div>' : '') +
            '<div class="cart-item-bottom">' +
              '<div class="cart-qty">' +
                '<button onclick="changeCartLine(\'' + item.key + '\',' + (item.quantity - 1) + ')" aria-label="Decrease quantity">-</button>' +
                '<span>' + item.quantity + '</span>' +
                '<button onclick="changeCartLine(\'' + item.key + '\',' + (item.quantity + 1) + ')" aria-label="Increase quantity">+</button>' +
              '</div>' +
              '<div class="cart-item-price">' + money(item.final_line_price) + '</div>' +
            '</div>' +
          '</div>' +
        '</div>';
    }).join('');

    var subEl = qs('cartSubtotal');
    if (subEl) subEl.textContent = money(cartState.items_subtotal_price);
    updateShippingBar(cartState.items_subtotal_price);
    renderCartSuggestions();
  }

  /* Up to two products not yet in the cart, with a one-tap add */
  function renderCartSuggestions() {
    var body = qs('cartBody');
    if (!body || !SUGGESTIONS.length || !cartState) return;
    var box = qs('cartSuggestions');
    var inCart = {};
    cartState.items.forEach(function (item) { inCart[item.id] = true; });
    var picks = SUGGESTIONS.filter(function (p) { return !inCart[p.variantId]; }).slice(0, 2);
    if (cartState.items.length === 0 || picks.length === 0) {
      if (box) box.remove();
      return;
    }
    if (!box) {
      box = document.createElement('div');
      box.id = 'cartSuggestions';
      box.className = 'cart-suggestions';
      body.appendChild(box);
    }
    box.innerHTML = '<p class="cart-suggestions-title">You may also like</p>' +
      picks.map(function (p) {
        return '' +
        '<div class="cart-suggestion">' +
          '<div class="cart-item-image">' +
            (p.image ? '<img src="' + esc(p.image) + '" alt="' + esc(p.title) + '" width="48" height="48" loading="lazy">' : '') +
          '</div>' +
          '<div class="cart-suggestion-info">' +
            '<a class="cart-suggestion-name" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
            '<span class="cart-suggestion-price">' + money(p.price) +
              (p.compare > p.price ? ' <s>' + money(p.compare) + '</s>' : '') + '</span>' +
          '</div>' +
          '<button class="cart-suggestion-add" onclick="vitamiraAddToCart(' + p.variantId + ',1,\'' + esc(p.title).replace(/'/g, "\\'") + '\')" aria-label="Add ' + esc(p.title) + ' to cart">Add</button>' +
        '</div>';
      }).join('');
  }

  /* First-order 10% note in the cart footer, aligned with the promo flyout */
  function renderCartPromoNote() {
    if (localStorage.getItem('vitamira_promo_claimed')) return;
    var footer = qs('cartFooter');
    if (!footer || qs('cartPromoNote') || !qs('promoFlyout')) return;
    var note = document.createElement('p');
    note.id = 'cartPromoNote';
    note.className = 'cart-promo-note';
    note.innerHTML = 'First order? <button type="button" onclick="promoFromCart()">Sign up for 10% off</button> and we\'ll send you a code.';
    footer.insertBefore(note, footer.querySelector('.btn'));
  }

  window.promoFromCart = function () {
    toggleCart();
    var el = qs('promoFlyout');
    if (el && !el.classList.contains('open')) togglePromo();
  };

  function updateShippingBar(subtotal) {
    var bar = qs('shippingBar');
    if (!bar) return;
    var fill = bar.querySelector('.shipping-bar-fill');
    var label = bar.querySelector('.shipping-bar-label');
    var remaining = THRESHOLD - subtotal;
    var pct = Math.min(100, (subtotal / THRESHOLD) * 100);
    fill.style.width = pct + '%';
    if (remaining > 0) {
      label.textContent = "You're " + money(remaining) + ' away from free shipping';
      bar.classList.remove('unlocked');
    } else {
      label.textContent = "You've unlocked free shipping 🎉";
      bar.classList.add('unlocked');
    }
  }

  window.toggleCart = function () {
    var drawer = qs('cartDrawer');
    var overlay = qs('cartOverlay');
    if (!drawer) return;
    if (drawer.classList.contains('active')) {
      drawer.classList.remove('active');
      overlay.classList.remove('active');
      document.body.style.overflow = '';
    } else {
      openCartDrawer();
    }
  };

  window.openCartDrawer = function () {
    var drawer = qs('cartDrawer');
    var overlay = qs('cartOverlay');
    if (!drawer) return;
    drawer.classList.add('active');
    overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  };

  /* --- Header / navigation --- */
  window.toggleMenu = function () {
    var nav = qs('nav');
    if (!nav) return;
    nav.classList.toggle('active');
    var btn = document.querySelector('.mobile-menu-btn');
    if (btn) btn.setAttribute('aria-expanded', nav.classList.contains('active'));
  };

  function initScrollEffects() {
    var header = qs('header');
    if (header) {
      window.addEventListener('scroll', function () {
        header.classList.toggle('scrolled', window.scrollY > 10);
      }, { passive: true });
    }
    document.querySelectorAll('a[href^="#"]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var href = link.getAttribute('href');
        if (href.length < 2) return;
        var target = document.querySelector(href);
        if (target) {
          e.preventDefault();
          var top = target.getBoundingClientRect().top + window.scrollY - 72;
          window.scrollTo({ top: top, behavior: 'smooth' });
          var nav = qs('nav');
          if (nav) nav.classList.remove('active');
        }
      });
    });
  }

  /* --- Rotating announcement bar --- */
  function initAnnouncementRotator() {
    var bar = document.querySelector('.announcement-bar p');
    if (!bar || !bar.dataset.messages) return;
    var messages;
    try { messages = JSON.parse(bar.dataset.messages); } catch (e) { return; }
    if (!messages || messages.length < 2) return;
    var i = 0;
    setInterval(function () {
      i = (i + 1) % messages.length;
      bar.style.opacity = '0';
      setTimeout(function () {
        bar.textContent = messages[i];
        bar.style.opacity = '1';
      }, 300);
    }, 4000);
  }

  /* --- Promo flyout (10% off signup) --- */
  function initPromoFlyout() {
    var el = qs('promoFlyout');
    if (!el) return;
    if (localStorage.getItem('vitamira_promo_claimed')) { el.remove(); return; }
    el.hidden = false;
  }

  window.togglePromo = function () {
    var el = qs('promoFlyout');
    if (!el) return;
    var open = el.classList.toggle('open');
    el.querySelector('.promo-tab').setAttribute('aria-expanded', String(open));
  };

  /* --- Product-page 10% off popup: same offer as the flyout, shown once
     per visit after a short delay, snoozed for a week when dismissed and
     gone for good once the code has been claimed anywhere on the site. --- */
  var POPUP_DELAY_MS = 2000;
  var POPUP_SNOOZE_MS = 7 * 24 * 60 * 60 * 1000;

  function removePromoPopup() {
    var el = qs('promoPopup');
    if (!el) return;
    if (el.classList.contains('visible')) document.documentElement.style.overflow = '';
    el.remove();
  }

  function initPromoPopup() {
    var el = qs('promoPopup');
    if (!el) return;
    if (localStorage.getItem('vitamira_promo_claimed')) { el.remove(); return; }
    try {
      var snooze = parseInt(localStorage.getItem('vitamira_promo_popup_snooze') || '0', 10);
      if (snooze && Date.now() < snooze) return;
      if (sessionStorage.getItem('vm_popup_shown')) return;
    } catch (err) {}
    setTimeout(function () {
      if (!document.body.contains(el)) return;
      if (localStorage.getItem('vitamira_promo_claimed')) { el.remove(); return; }
      var flyout = qs('promoFlyout');
      if (flyout && flyout.classList.contains('open')) return;
      try { sessionStorage.setItem('vm_popup_shown', '1'); } catch (err) {}
      el.hidden = false;
      requestAnimationFrame(function () { el.classList.add('visible'); });
      document.documentElement.style.overflow = 'hidden';
      var card = el.querySelector('.promo-popup');
      if (card) card.focus();
    }, POPUP_DELAY_MS);
  }

  window.closePromoPopup = function () {
    var el = qs('promoPopup');
    if (!el || el.hidden) return;
    el.classList.remove('visible');
    document.documentElement.style.overflow = '';
    try { localStorage.setItem('vitamira_promo_popup_snooze', String(Date.now() + POPUP_SNOOZE_MS)); } catch (err) {}
    setTimeout(function () { el.hidden = true; }, 260);
  };

  document.addEventListener('click', function (e) {
    var overlay = e.target.closest && e.target.closest('.promo-popup-overlay');
    if (overlay && e.target === overlay) closePromoPopup();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var el = qs('promoPopup');
    if (el && !el.hidden) closePromoPopup();
  });

  /* Quick-view cards for a bundle's included products. The overlays are
     moved to <body> so position:fixed is never trapped by a transformed
     ancestor (e.g. reveal animations), keeping the card centred on screen. */
  function initBundleQuick() {
    var overlays = document.querySelectorAll('.bundle-quick-overlay');
    Array.prototype.forEach.call(overlays, function (el) {
      var w = document.createElement('div');
      w.className = 'vpdp';
      document.body.appendChild(w);
      w.appendChild(el);
    });
  }

  window.openBundleQuick = function (n) {
    var el = qs('bundleQuick' + n);
    if (!el) return;
    el.hidden = false;
    requestAnimationFrame(function () { el.classList.add('visible'); });
    document.documentElement.style.overflow = 'hidden';
  };
  window.closeBundleQuick = function (n) {
    var el = qs('bundleQuick' + n);
    if (!el) return;
    el.classList.remove('visible');
    document.documentElement.style.overflow = '';
    setTimeout(function () { el.hidden = true; }, 240);
  };
  document.addEventListener('click', function (e) {
    var overlay = e.target.closest && e.target.closest('.bundle-quick-overlay');
    if (overlay && e.target === overlay) closeBundleQuick(overlay.id.replace('bundleQuick', ''));
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = document.querySelector('.bundle-quick-overlay:not([hidden])');
    if (open) closeBundleQuick(open.id.replace('bundleQuick', ''));
  });

  /* Post-signup confirmation modal: the code is emailed, so tell people it
     is coming and to check spam if it does not show up. */
  function showSignupModal() {
    var wrap = document.createElement('div');
    wrap.className = 'vpdp';
    wrap.innerHTML =
      '<div class="promo-modal-overlay" role="dialog" aria-modal="true" aria-label="Your code is on its way">' +
        '<div class="promo-modal">' +
          '<div class="promo-modal-icon" aria-hidden="true"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="4" width="20" height="16" rx="2"/><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/></svg></div>' +
          '<h3>Your code is on its way!</h3>' +
          '<p>We’ve sent your 10% off code to your email. It usually arrives within a couple of minutes.</p>' +
          '<p class="promo-modal-spam">Not there yet? Check your spam or promotions folder, and add us to your contacts so you never miss it.</p>' +
          '<button type="button" class="btn btn-primary">Got it</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(wrap);
    var overlay = wrap.querySelector('.promo-modal-overlay');
    requestAnimationFrame(function () { overlay.classList.add('visible'); });
    function close() {
      overlay.classList.remove('visible');
      setTimeout(function () { wrap.remove(); }, 260);
    }
    wrap.querySelector('.btn').addEventListener('click', close);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
  }

  /* Submit signup forms in place so the page never reloads or scrolls; the
     confirmation modal appears at the current position. Falls back to the
     native post (and the return-marker flow below) on network errors, and
     follows Shopify's captcha challenge when one is issued. */
  function initSignupAjax() {
    var forms = document.querySelectorAll('form.promo-form, form.newsletter-form');
    Array.prototype.forEach.call(forms, function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        try { sessionStorage.setItem('vm_scroll', String(Math.round(window.scrollY))); } catch (err) {}
        var btn = form.querySelector('button[type="submit"]');
        var label = btn ? btn.textContent : '';
        if (btn) { btn.disabled = true; btn.textContent = 'Sending…'; }
        fetch(form.getAttribute('action') || '/contact', { method: 'POST', body: new FormData(form) })
          .then(function (resp) {
            /* Only trust success when Shopify redirected back to our
               return_to marker (vm=...) or its default customer_posted
               param. Anything else (captcha challenge, throttle, error
               re-render) falls back to a native post so Shopify can run
               its own flow; the vm marker confirms it after reload. The
               captcha fires far more often on mobile, where navigating
               to the challenge URL after an AJAX post silently dropped
               the pending signup. */
            var url = resp.url || '';
            var succeeded = resp.ok && url.indexOf('challenge') === -1 &&
              (url.indexOf('vm=') !== -1 || url.indexOf('customer_posted=true') !== -1);
            if (!succeeded) { form.submit(); return; }
            try { sessionStorage.removeItem('vm_scroll'); } catch (err) {}
            if (form.classList.contains('promo-form')) {
              localStorage.setItem('vitamira_promo_claimed', '1');
              var el = qs('promoFlyout');
              if (el) el.remove();
              var note = qs('cartPromoNote');
              if (note) note.remove();
              removePromoPopup();
            } else {
              form.reset();
              if (btn) { btn.disabled = false; btn.textContent = label; }
            }
            showSignupModal();
          })
          .catch(function () {
            if (btn) { btn.disabled = false; btn.textContent = label; }
            form.submit();
          });
      });
    });
  }

  /* Newsletter / promo forms post natively to Shopify; the return_to URL
     carries a marker so we can confirm on reload. */
  function initSignupReturnMarkers() {
    var params = new URLSearchParams(window.location.search);
    var marker = params.get('vm');
    var posted = params.get('customer_posted');
    if (!marker && posted !== 'true') return;
    /* Shopify's post-signup / post-challenge redirect appends #contact_form,
       which anchors the browser to the footer form. Jump back to where the
       visitor actually was when they submitted. */
    try {
      var y = sessionStorage.getItem('vm_scroll');
      if (y !== null) {
        sessionStorage.removeItem('vm_scroll');
        window.scrollTo(0, parseInt(y, 10) || 0);
      }
    } catch (err) {}
    if (marker === 'promo') {
      localStorage.setItem('vitamira_promo_claimed', '1');
      showSignupModal();
      var el = qs('promoFlyout');
      if (el) el.remove();
      var note = qs('cartPromoNote');
      if (note) note.remove();
      removePromoPopup();
    } else {
      showSignupModal();
    }
    params.delete('vm');
    params.delete('customer_posted');
    var hash = window.location.hash === '#contact_form' ? '' : window.location.hash;
    var clean = window.location.pathname + (params.toString() ? '?' + params.toString() : '') + hash;
    window.history.replaceState({}, '', clean);
  }

  /* --- FAQ accordion --- */
  window.toggleFaq = function (btn) {
    var item = btn.closest('.faq-item');
    var wasActive = item.classList.contains('active');
    document.querySelectorAll('.faq-item').forEach(function (i) {
      i.classList.remove('active');
      var q = i.querySelector('.faq-question');
      if (q) q.setAttribute('aria-expanded', 'false');
    });
    if (!wasActive) {
      item.classList.add('active');
      btn.setAttribute('aria-expanded', 'true');
    }
  };

  /* --- Scroll reveal --- */
  function initReveal() {
    var items = document.querySelectorAll('.reveal');
    if (!items.length) return;
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('visible'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    items.forEach(function (el) { observer.observe(el); });
  }

  /* --- Marquee: clone the group until it covers any viewport --- */
  function initMarquee() {
    var run = function () {
      document.querySelectorAll('.marquee-track').forEach(function (track) {
        var group = track.querySelector('.marquee-group');
        if (!group) return;
        var groupWidth = group.getBoundingClientRect().width;
        if (!groupWidth) return;
        var coverage = Math.max(window.innerWidth, (window.screen && window.screen.width) || 0) * 1.5;
        var needed = Math.max(2, Math.ceil(coverage / groupWidth) + 1);
        var current = track.querySelectorAll('.marquee-group').length;
        while (current < needed) {
          track.appendChild(group.cloneNode(true));
          current++;
        }
        track.style.setProperty('--marquee-shift', groupWidth + 'px');
        track.style.setProperty('--marquee-duration', Math.round(groupWidth / 55) + 's');
      });
    };
    run();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(run);
    window.addEventListener('resize', run);
  }

  /* --- Hero slideshow (homepage) --- */
  function initHeroRotator() {
    var slides = document.querySelectorAll('.hp-hero-slide');
    var bars = document.querySelectorAll('.hp-hero-bar');
    var chip = qs('heroChip');
    var chipName = qs('heroChipName');
    var badge = qs('heroAusBadge');
    if (slides.length < 2 || !chip || !chipName) return;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var DURATION = 3500;
    var i = 0;
    var timer = null;

    function show(index) {
      i = index;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      bars.forEach(function (b, k) {
        b.classList.toggle('is-active', k === i);
        b.setAttribute('aria-selected', k === i ? 'true' : 'false');
      });
      var slide = slides[i];
      chip.style.opacity = '0';
      setTimeout(function () {
        chipName.textContent = slide.dataset.name;
        chip.href = slide.dataset.url;
        chip.style.opacity = '1';
      }, 250);
      if (badge) badge.classList.toggle('is-hidden', slide.dataset.au !== '1');
    }

    function restartTimer() {
      if (reduced) return;
      clearInterval(timer);
      timer = setInterval(function () { show((i + 1) % slides.length); }, DURATION);
    }

    bars.forEach(function (b, k) {
      b.addEventListener('click', function () { show(k); restartTimer(); });
    });
    restartTimer();
  }

  /* --- PDP: gallery, quantity, pricing, sticky bar --- */
  var PDP = { variantId: 0, unitPrice: 0, qty: 1, name: '' };

  function initPdp() {
    var btn = qs('atcBtn');
    if (!btn) return;
    PDP.variantId = Number(btn.dataset.variantId) || 0;
    PDP.unitPrice = Number(btn.dataset.unitPrice) || 0; /* cents */
    PDP.name = btn.dataset.name || 'Product';

    var main = qs('galleryMain');
    document.querySelectorAll('.gallery-thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        document.querySelectorAll('.gallery-thumb').forEach(function (t) {
          t.classList.remove('active');
          t.setAttribute('aria-selected', 'false');
        });
        thumb.classList.add('active');
        thumb.setAttribute('aria-selected', 'true');
        var current = qs('galleryImage');
        var clone = current.cloneNode();
        clone.src = thumb.dataset.src;
        clone.alt = thumb.dataset.alt || '';
        clone.id = 'galleryImage';
        if (main) main.classList.toggle('is-contain', thumb.dataset.contain === 'true');
        current.replaceWith(clone);
      });
    });

    var select = qs('qtySelect');
    if (select) {
      select.addEventListener('change', function () {
        PDP.qty = parseInt(select.value, 10) || 0;
        updatePdpPricing();
      });
    }
    updatePdpPricing();

    var bar = qs('stickyAtc');
    if (bar && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        var entry = entries[0];
        var passed = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
        bar.classList.toggle('visible', passed);
        bar.setAttribute('aria-hidden', String(!passed));
      }, { threshold: 0 });
      observer.observe(btn);
    }
  }

  function updatePdpPricing() {
    var total = PDP.unitPrice * PDP.qty;
    var atcPrice = qs('atcPrice');
    var stickyPrice = qs('stickyPrice');
    var btn = qs('atcBtn');
    if (atcPrice) atcPrice.textContent = money(total);
    if (stickyPrice) stickyPrice.textContent = money(total);
    if (btn) btn.disabled = PDP.qty === 0;
  }

  window.pdpAddToCart = function () {
    if (PDP.qty < 1) { showToast('Select a quantity first'); return; }
    vitamiraAddToCart(PDP.variantId, PDP.qty, PDP.name);
  };

  window.pdpBuyNow = function () {
    if (PDP.qty < 1) { showToast('Select a quantity first'); return; }
    vitamiraBuyNow(PDP.variantId, PDP.qty);
  };

  /* --- Boot --- */
  function boot() {
    initScrollEffects();
    initAnnouncementRotator();
    initPromoFlyout();
    initPromoPopup();
    initBundleQuick();
    initSignupAjax();
    initSignupReturnMarkers();
    initReveal();
    initMarquee();
    initHeroRotator();
    initPdp();
    fetchCart().then(renderCartPromoNote);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
